export const getLocale = state => state?.settings?.locale?.locale || 'en';
